"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCurrentEmployerData = exports.currentEmployerFormRules = exports.currentEmployerSchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.currentEmployerSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Current Employer must be 200 characters or less',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.currentEmployerFormRules = (0, converters_1.toReactHookForm)(exports.currentEmployerSchema, income_1.incomeFieldMapping);
exports.validateCurrentEmployerData = (0, converters_1.createValidator)(exports.currentEmployerSchema);
